import { render } from "./Footer.vue?vue&type=template&id=2819d1e2&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=2819d1e2&scoped=true&lang=scss"

import exportComponent from "/Volumes/Quoicoubeh/Paraleclypse/website/paraleclypse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2819d1e2"]])

export default __exports__